import Chart from 'chartjs';

window.Chart = Chart;
